import { Component, Input, OnInit } from '@angular/core';
import { IEnvironmentDetails } from '../../interfaces/environment-details';

@Component({
  selector: 'app-environment-info',
  templateUrl: './environment-info.component.html',
  styleUrls: ['./environment-info.component.sass']
})

export class EnvironmentInfoComponent implements OnInit {

  @Input() currentEnvironment: IEnvironmentDetails;

  constructor() { }

  ngOnInit(): void {  }

}
